import { Component, Input } from '@angular/core';
import {
  skeletonFilterWidthClass,
  skeletonIndexes,
  skeletonIndexesExact,
  type SkeletonVariant,
} from './skeleton.util';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
})
export class SkeletonComponent {
  @Input() variant: SkeletonVariant = 'table';
  @Input() columns = 6;
  @Input() rows = 8;
  @Input() cards = 6;
  @Input() label = 'Načítání…';

  /** Filter bar above table/list (search + multi-selects). */
  @Input() showFilters = false;
  @Input() filterCount = 3;
  @Input() includeSearchFilter = true;

  /** Section toolbar: title pill + action buttons. */
  @Input() showToolbar = false;
  @Input() toolbarActions = 0;
  @Input() toolbarIconActions = 0;

  /** Detail form field count. */
  @Input() detailFields = 6;

  /** Multi-section list pages (e.g. owners + parcels + contracts). */
  @Input() sectionCount = 3;
  @Input() sectionColumns = 6;
  @Input() sectionRows = 4;
  @Input() sectionFilterCount = 1;

  indexes(count: number): number[] {
    return skeletonIndexes(count);
  }

  indexesExact(count: number): number[] {
    return skeletonIndexesExact(count);
  }

  filterClass(index: number): string {
    return skeletonFilterWidthClass(index, this.includeSearchFilter);
  }

  get resolvedFilterCount(): number {
    const n = Math.max(0, this.filterCount);
    if (!this.includeSearchFilter) return Math.max(1, n);
    return Math.max(1, n);
  }
}
